import script from "./PCMall.vue?vue&type=script&lang=ts&setup=true"
export * from "./PCMall.vue?vue&type=script&lang=ts&setup=true"

import "./PCMall.vue?vue&type=style&index=0&id=6cef3cd0&lang=scss&scoped=true"

import exportComponent from "E:\\workspace13\\aries-backend-front\\kailas-aries\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_64f3209c872a893711b3e776f2c9ff1e\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cef3cd0"]])

export default __exports__